import FeatureFlagsService from '@services/featureFlags';
import { useQuery } from '@tanstack/react-query';

export const useFetchFeatureFLags = () => useQuery({ queryKey: ['feature-flags'], queryFn: FeatureFlagsService.get });
